/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CliproConnectivityPagedList } from '../../models/clipro-connectivity-paged-list';
import { CliproConnectivitySearchBody } from '../../models/clipro-connectivity-search-body';
import { ServiceType } from '../../models/service-type';

export interface SearchCliproConnectivity$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The station service type for filter
 */
  serviceTypes?: Array<ServiceType>;
  
    /**
     * Body for search clipro connectivity
     */
    body?: CliproConnectivitySearchBody
}

export function searchCliproConnectivity$Json(http: HttpClient, rootUrl: string, params?: SearchCliproConnectivity$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CliproConnectivityPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchCliproConnectivity$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('serviceTypes', params.serviceTypes, {"style":"form","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CliproConnectivityPagedList>;
    })
  );
}

searchCliproConnectivity$Json.PATH = '/custom/stations/clipro/connectivity/search';
